import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, Alert } from '@mui/material';
import CodeRunner from '../components/CodeRunner';

const VALID_LANGS = ['python', 'r', 'html'];

const EditorLauncher = () => {
  const [searchParams] = useSearchParams();
  const lang = searchParams.get('lang');
  const isValid = VALID_LANGS.includes(lang);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Code Editor
      </Typography>
      {!isValid ? (
        <Alert severity="warning">Please provide a valid editor language (?lang=python, r, or html)</Alert>
      ) : (
        <CodeRunner autoDetect={false} resetTrigger={lang} />
      )}
    </Box>
  );
};

export default EditorLauncher;
